export const APP_AUTH_TYPE = {
    OKTA: 'okta',
    AZURE: 'azure'
};
export const APP_AUTH_TYPE_AZURE = 'azure';

export type appModeProps = typeof APP_AUTH_TYPE.OKTA | typeof APP_AUTH_TYPE.AZURE;

export const appMode: appModeProps = APP_AUTH_TYPE.AZURE;